import { thumbStaticUrl } from "./assetImage";

/** 人员列表：仅保留相对路径；缩略图由 Nginx 静态 URL 提供 */
export function applyStaffPhoto(item: Record<string, unknown>, relativePath: string | null | undefined): void {
  if (!relativePath) {
    item.photoRel = null;
    item.photoThumbSrc = null;
    return;
  }
  item.photoRel = String(relativePath).replace(/^\/+/, "");
  item.photoThumbSrc = null;
}

export function staffPhotoRelFromItem(item: Record<string, unknown>): string | null {
  const list = item.imagelist as string[] | undefined;
  if (list && list.length > 0) return list[0];
  if (item.photo && typeof item.photo === "string" && !item.photo.startsWith("http")) {
    return item.photo as string;
  }
  if (item.photoRel && typeof item.photoRel === "string") {
    return item.photoRel as string;
  }
  return null;
}

/** 为列表项设置缩略图静态 URL（不再 POST /api/get-images） */
export function prefetchStaffPhotoThumbs(items: Record<string, unknown>[]): void {
  items.forEach((item) => {
    const rel = staffPhotoRelFromItem(item);
    applyStaffPhoto(item, rel);
    if (item.photoRel) {
      item.photoThumbSrc = thumbStaticUrl(item.photoRel as string);
    }
  });
}
